import React from "react";

function Title({ children }) {
  return <h1 className="tcf-title">{children}</h1>;
}

export default Title;
